import React from 'react';
import { FadeIn } from './FadeIn';
import { Scale, EyeOff } from 'lucide-react';
export const WhyTwoOpinions = () => {
  return <section className="py-24 bg-offwhite" data-id="element-315">
      <div className="max-w-4xl mx-auto px-6 text-center" data-id="element-316">
        <FadeIn data-id="element-317">
          <h2 className="font-serif text-3xl md:text-4xl text-navy mb-6" data-id="element-318">
            Почему два мнения, а не одно?
          </h2>
          <p className="text-lg text-navyLight mb-16 max-w-2xl mx-auto" data-id="element-319">
            Даже опытные эксперты могут смотреть на один и тот же снимок
            по-разному. Мы используем метод «слепого рецензирования», чтобы
            исключить влияние одного мнения на другое.
          </p>
        </FadeIn>

        <div className="grid md:grid-cols-3 gap-8 items-center relative" data-id="element-320">
          <FadeIn delay={0.1} className="bg-white p-8 rounded-2xl shadow-soft relative z-10" data-id="element-321">
            <div className="w-12 h-12 bg-beige rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-322">
              <span className="font-serif font-bold text-xl text-navy" data-id="element-323">Э1</span>
            </div>
            <p className="text-sm text-navyLight" data-id="element-324">
              Самостоятельно анализирует ваши документы и формирует экспертное
              мнение.
            </p>
          </FadeIn>

          <FadeIn delay={0.2} className="flex flex-col items-center justify-center gap-4 relative z-0" data-id="element-325">
            <div className="hidden md:block absolute top-1/2 left-0 w-full h-0.5 bg-beige -z-10" data-id="element-326" />
            <div className="bg-offwhite p-2" data-id="element-327">
              <EyeOff size={32} className="text-sage" data-id="element-328" />
            </div>
            <p className="text-xs font-medium text-navyLight uppercase tracking-wider" data-id="element-329">
              Не видят выводы друг друга
            </p>
          </FadeIn>

          <FadeIn delay={0.3} className="bg-white p-8 rounded-2xl shadow-soft relative z-10" data-id="element-330">
            <div className="w-12 h-12 bg-beige rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-331">
              <span className="font-serif font-bold text-xl text-navy" data-id="element-332">Э2</span>
            </div>
            <p className="text-sm text-navyLight" data-id="element-333">
              Делает то же самое — независимо от первого эксперта.
            </p>
          </FadeIn>
        </div>

        <FadeIn delay={0.4} className="mt-16 bg-sageLight rounded-2xl p-8 max-w-2xl mx-auto" data-id="element-334">
          <div className="flex items-start gap-4 text-left" data-id="element-335">
            <Scale size={24} className="text-sage shrink-0 mt-1" data-id="element-336" />
            <div data-id="element-337">
              <h4 className="font-medium text-navy text-lg mb-2" data-id="element-338">
                Что в итоге?
              </h4>
              <p className="text-navyLight leading-relaxed" data-id="element-339">
                Если оба эксперта сходятся во мнении — вы получаете уверенность
                в оценке. Если их выводы расходятся (такое бывает примерно в 15%
                случаев), мы привлекаем третьего эксперта{' '}
                <strong data-id="element-340">бесплатно</strong>, чтобы помочь вам разобраться глубже.
              </p>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
};